import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent {

  isNavOpen = false;

  // navTog button click → toggle
  toggleNav(): void {
    this.isNavOpen = !this.isNavOpen;
  }

  // Link click pe close
  closeNav(): void {
    this.isNavOpen = false;
  }

  // Nav ke bahar click pe close
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.unav')) {
      this.isNavOpen = false;
    }
  }

}
